import { alert } from "../core/alert";
import { getErrorCodeName, getErrorMessage, getErrorMessageHeader } from "../core/errorHandling";
import { getErrorCode } from "../core/getErrorCode";
import { settings } from "../core/settings";

export function showAjaxResponseMessages() {

    $(document).ajaxSuccess(function (event, xhr) {
        var data = null;
        try {
            data = $.parseJSON(xhr.responseText);
        } catch (e) {
        }

        if (settings.showDebugMessages) {
            var message = "";

            if (data) {
                message += buildResponseMessage(data);
            }

            if (message.length > 0) {
                alert({
                    header: "Warning",
                    type: "warning",
                    message: message,
                    messageIsHTML: true,
                    fade: false
                });
            }
        }

        var warningMessage = buildWarningMessage(data);
        if (warningMessage) {
            alert({
                header: "Warning",
                type: "warning",
                message: warningMessage,
                messageIsHTML: true,
                fade: true
            });
        }
    });

    $(document).ajaxError(function (event, xhr) {

        if (settings.showDebugMessages) {
            var data = null,
            status = xhr.status,
            message = "";

            try {
                data = $.parseJSON(xhr.responseText);
            } catch (e) {
            }

            switch (status) {
            case 400:
                message = "Bad Request.";
                break;
            case 401:
                message = "Unauthorized.";
                break;
            case 403:
                message = "Forbidden.";
                break;
            case 404:
                message = "Not Found.";
                break;
            case 406:
                message = "Not Acceptable.";
                break;
            case 409:
                message = "Conflict.";
                break;
            case 410:
                message = "Gone.";
                break;
            case 500:
                message = "Internal Server Error.";
                break;
            case 502:
                message = "Bad Gateway.";
                break;
            case 503:
                message = "Service Unavailable.";
                break;
            case 504:
                message = "Gateway Timeout.";
                break;
            }

            if (message.length > 0) {

                var errorCode = getErrorCode(xhr);
                if (errorCode) {
                    message += "<div class='alert-section'><span class='alert-header'>Error Code " + errorCode + "</span> " + getErrorCodeName(errorCode) + "</div>";
                }

                if (data) {
                    message += " " + buildResponseMessage(data);
                }

                alert({
                    header: "Developer Only Error || Status Code " + status,
                    type: "info",
                    message: message,
                    messageIsHTML: true,
                    fade: false
                });
            }
        }
    });
}

export function buildResponseMessage(data) {
    var message = "";

    if (data.Errors) {
        $.each(data.Errors.Validation, function (index, validationError) {
            message += "<div class='alert-section'><span class='alert-header'>" + validationError.Record + " has validation issues</span></div>";

            $.each(validationError.Fields, function (fieldIndex, field) {
                message += "<div class='alert-sub-section'><span class='alert-header'>" + field.Name + "</span> " + field.Message + "</div>";
            });
        });

        $.each(data.Errors.General, function (index, generalError) {
            message += "<div class='alert-section'><span class='alert-header'>" + generalError.Error + "</span> " + generalError.Details + "</div>";
        });
    }

    return message;
}

export function buildWarningMessage(data) {
    var message = "";
    if (data && data.Warnings && data.Warnings.General && data.Warnings.General.length > 0) {
        $.each(data.Warnings.General, function (index, warning) {
            if (warning.ErrorCode != 0) {
                var errorCode = getErrorMessageHeader({errorCode: warning.ErrorCode}) || getErrorCodeName(warning.ErrorCode);
                var errorMessage = getErrorMessage({ errorCode: warning.ErrorCode });
                message += "<div class='alert-section'><span class='alert-header'>" + errorCode + "</span> " + errorMessage + "</div>";
            }
        });
    }
    return message;
}
